module.exports = __webpack_public_path__ + "static/media/chinese_05.bf6255a7.jpg";